import { initSentry } from "./lib/sentry";
import { initPostHog } from "./lib/posthog";
import { reportWebVitals } from "./lib/web-vitals";
import { registerServiceWorker } from "./lib/pwa";

// Initialize monitoring before anything else
initSentry();
initPostHog(); // Only activates if user has previously accepted cookies

import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

createRoot(document.getElementById("root")!).render(<App />);

// Report Core Web Vitals (LCP, FID, CLS, FCP, TTFB, INP)
reportWebVitals();

// Register PWA service worker (controlled by ff.pwa flag)
registerServiceWorker();
